export default __webpack_public_path__ + "static/media/re.fc3f27e8.svg";